import { useState, useCallback } from 'react';

export const useDateRange = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const selectDate = useCallback(
    (date) => {
      if (!startDate || (startDate && endDate)) {
        // Start new selection
        setStartDate(date);
        setEndDate(null);
      } else if (startDate && !endDate) {
        if (date < startDate) {
          // If selected date is before start, swap
          setStartDate(date);
          setEndDate(startDate);
        } else {
          setEndDate(date);
        }
      }
    },
    [startDate, endDate]
  );

  const clearSelection = useCallback(() => {
    setStartDate(null);
    setEndDate(null);
  }, []);

  return { startDate, endDate, selectDate, clearSelection };
};